<script>
    import IconBar from './IconBar.svelte';
    export let value, pulse, isCeo;
    const choices = [[10, "10"], [9, "9"], [8, "8"], [7, "7"], [6, "6"], [5, "5"], [4, "4"], [3, "3"], [2, "2"], [1, "1"], [0, "0"]];
</script>


{#if value != null}
    <IconBar {value} {pulse} danger={isCeo && value < 3} title="Impact" icon="impact" {choices} />
{/if}
